var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatUnread = function SvgChatUnread(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 14,
    "data-width-24": 21,
    viewBox: "0 0 20.74 19.66",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.74 19.65A1.75 1.75 0 0 1 0 17.86V4.65a2.31 2.31 0 0 1 2.3-2.3h12.9a2.31 2.31 0 0 1 2.3 2.3v9.29a2.3 2.3 0 0 1-2.3 2.3H6.33l-3.38 3a1.75 1.75 0 0 1-1.21.41m.51-15.8a.8.8 0 0 0-.8.8v13.21a.27.27 0 0 0 .17.26.26.26 0 0 0 .3-.05l3.59-3.14a.78.78 0 0 1 .5-.19h9.14a.8.8 0 0 0 .8-.8V4.65a.8.8 0 0 0-.8-.8zm4.43 6.87h-1a.75.75 0 1 1 0-1.5h1a.75.75 0 1 1 0 1.5m4.16 0h1a.75.75 0 1 0 0-1.5h-1a.75.75 0 1 0 0 1.5",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.74 8a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatUnread);
export default ForwardRef;